import { struct } from 'io-ts/Decoder';

import { Id as FileId } from '../../../file/Id';
import { ParentId } from '../../../file/ParentId';

export const Params = struct({
	parentId: ParentId,
	fileId: FileId,
});
